import React from 'react';
import {
  TextInput,
  Group,
  Button,
  Grid,
  Flex,
  Stack
} from '@mantine/core';
import {
  IconSearch,
} from '@tabler/icons-react';
import { DateInput } from '@mantine/dates';

const FiltroAutos = ({
  valorBusca,
  setValorBusca,
  municipio,
  setMunicipio,
  numeroAuto,
  setNumeroAuto,
  dataInicio,
  setDataInicio,
  dataFim,
  setDataFim,
  limparFiltros,
  aplicarFiltros
}) => {
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
        aplicarFiltros()
    }
}
  return (
    <Stack onKeyDown={handleKeyDown}>
      <Grid mb="md">
        <Grid.Col span={12}>
          <Flex
            direction={{ base: 'column', sm: 'row' }}
            gap="sm"
            align={{ base: 'stretch', sm: 'flex-end' }}
          >
            <TextInput
              placeholder="Pesquise por nome/razão social, CPF ou palavra-chave"
              value={valorBusca || ''}
              onChange={(event) => setValorBusca(event.currentTarget.value)}
              rightSection={<IconSearch size={16} />}
              style={{ flex: 1 }}
            />
            <Group spacing="xs">
              <Button
                color="green"
                fw={'lighter'}
                radius={'xl'}
                onClick={aplicarFiltros}
                >
                  Aplicar filtros
                </Button>
                <Button
                  color="green"
                  variant="subtle"
                  fw={'lighter'}
                  radius={'xl'}
                  onClick={limparFiltros}
                >
                  Limpar
                </Button>
            </Group>
          </Flex>
        </Grid.Col>
      </Grid>

      <Grid mb="md">
        <Grid.Col span={3}>
          <TextInput
            label="Município:"
            value={municipio || ''}
            onChange={(event) => setMunicipio(event.currentTarget.value)}
          />
        </Grid.Col>
        <Grid.Col span={3}>
          <TextInput
            label="Número do Auto de Infração:"
            value={numeroAuto || ''}
            onChange={(event) => setNumeroAuto(event.currentTarget.value)}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <Group grow>
            <DateInput
              label="Período Inicial:"
              value={dataInicio}
              onChange={setDataInicio}
              placeholder={'DD/MM/AAAA'}
              size="sm"
              maxLength={10}
              dateParser={value => {
                const data = value.replace(/\D/g, '')
                if (data.length !== 8) {
                  return null
                }
                const dia = Number(data.slice(0, 2))
                const mes = Number(data.slice(2, 4)) - 1
                const ano = Number(data.slice(4, 8))
                if (
                  typeof dia === 'number' &&
                  typeof mes === 'number' &&
                  typeof ano === 'number'
                ) {
                  return new Date(ano, mes, dia)
                }
                return null
              }}
              maxDate={new Date()}
              valueFormat="DD/MM/YYYY"
              locale="pt-br"
              onKeyDown={e => {
                const input = e.target
                const value = input.value
                const length = value.length
                const key = e.key
                const nextCharIsNumber = /\d/.test(key)
                if (
                  nextCharIsNumber &&
                  (length === 2 || length === 5) &&
                  value[length - 1] !== '/'
                ) {
                  input.value = value + '/' + e.key
                  e.preventDefault()
                }
              }}
              clearable
            />
            <DateInput
              label="Período Final:"
              value={dataFim}
              onChange={setDataFim}
              placeholder={'DD/MM/AAAA'}
              size="sm"
              maxLength={10}
              dateParser={value => {
                const data = value.replace(/\D/g, '')
                if (data.length !== 8) {
                  return null
                }
                const dia = Number(data.slice(0, 2))
                const mes = Number(data.slice(2, 4)) - 1
                const ano = Number(data.slice(4, 8))
                if (
                  typeof dia === 'number' &&
                  typeof mes === 'number' &&
                  typeof ano === 'number'
                ) {
                  return new Date(ano, mes, dia)
                }
                return null
              }}
              maxDate={new Date()}
              valueFormat="DD/MM/YYYY"
              locale="pt-br"
              onKeyDown={e => {
                const input = e.target
                const value = input.value
                const length = value.length
                const key = e.key
                const nextCharIsNumber = /\d/.test(key)
                if (
                  nextCharIsNumber &&
                  (length === 2 || length === 5) &&
                  value[length - 1] !== '/'
                ) {
                  input.value = value + '/' + e.key
                  e.preventDefault()
                }
              }}
              clearable
            />
          </Group>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};

export default FiltroAutos;
